<span
  [attr.style]="style"
  [translate]="$any('UI.GROUP.EVENTS.GLOBAL_EVENT_TYPES.' + eventTypeId)"
></span>
